// @flow

import React, { memo } from 'react';
import { useLangFile } from 'js/context/LanguageContext';

import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { usePrescriptionJob } from 'js/components/Prescription/PrescriptionJobContext';
import EqualizerOutlinedIcon from '@mui/icons-material/EqualizerOutlined';

const PrescriptionAdjustButton = (props: PrescriptionAdjustButton.propTypes) => {
  const LangFile = useLangFile();
  const { prescriptionJob } = usePrescriptionJob();

  return (
    <Box
      sx={{
        ml: 1,
      }}
    >
      <Button variant={'contained'} color={'secondary'} onClick={props.onClick}>
        <EqualizerOutlinedIcon />
        <Box
          sx={{
            ml: 1,
          }}
        >
          {LangFile.PrescriptionAdjustButton.label}
        </Box>
      </Button>
    </Box>
  );
};

PrescriptionAdjustButton.propTypes = {
  onClick: PropTypes.func,
};

export default memo(PrescriptionAdjustButton);
